import React from 'react';
import { Mail, MessageCircle, Store, User, HelpCircle } from 'lucide-react';

const Contact = () => {
  const contactMethods = [
    {
      icon: Store,
      title: 'Merchant Support',
      description: 'For retailers looking to join Trendrush',
      email: 'merchant-support@trendrushindia.com',
      color: 'bg-blue-50 text-blue-600'
    },
    {
      icon: User,
      title: 'Customer Support',
      description: 'For consumer inquiries and assistance',
      email: 'customer-support@trendrushindia.com',
      color: 'bg-green-50 text-green-600'
    },
    {
      icon: HelpCircle,
      title: 'General Support',
      description: 'For any other questions or inquiries',
      email: 'support@trendrushindia.com',
      color: 'bg-purple-50 text-purple-600'
    }
  ];

  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-gray-50 to-cream/30">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Let's <span className="text-coral">Connect</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Ready to transform retail? Have questions? We're here to help you get started.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Contact Methods Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {contactMethods.map((method, index) => {
              const Icon = method.icon;
              return (
                <div
                  key={index}
                  className="feature-card group text-center px-6 py-8"
                >
                  <div className={`w-16 h-16 mx-auto mb-6 rounded-2xl ${method.color} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                    <Icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{method.title}</h3>
                  <p className="text-gray-600 mb-4 min-h-[48px]">{method.description}</p>
                  <a
                    href={`mailto:${method.email}`}
                    className="inline-flex items-center justify-center gap-2 text-coral font-semibold hover:underline break-all max-w-full text-sm"
                  >
                    <Mail className="w-4 h-4 flex-shrink-0" />
                    <span className="break-all">{method.email}</span>
                  </a>
                </div>
              );
            })}
          </div>

          {/* WhatsApp CTA */}
          <div className="bg-gradient-to-br from-coral to-coral/80 rounded-3xl p-12 text-center shadow-2xl">
            <div className="max-w-2xl mx-auto">
              <div className="w-20 h-20 mx-auto mb-6 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                <MessageCircle className="w-10 h-10 text-white" />
              </div>
              
              <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
                Ready to Get Started?
              </h3>
              
              <p className="text-xl text-white/90 mb-8">
                Connect with us instantly via email or WhatsApp
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://wa.me/918247034033?text=Hi%2C%20I%20want%20to%20know%20more%20about%20Trendrush"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white text-coral rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all"
                >
                  <MessageCircle className="w-6 h-6" />
                  <span>WhatsApp</span>
                </a>
                <a
                  href="mailto:support@trendrushindia.com"
                  className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-xl font-semibold text-lg hover:bg-white/20 transition-all"
                >
                  <Mail className="w-6 h-6" />
                  <span>Email Us</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
